import React from 'react';

export const IconGameProfile = () => {
  return (
    <span className="icon-svg IconGameProfile">
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15 15.5793H16.6667M16.6667 15.5793H18.3333M16.6667 15.5793V13.9126M16.6667 15.5793V17.2459"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.6665 9.74561H16.6665"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.6665 14.7456H11.6665"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.6665 4.74561H16.6665"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};
